import { t } from 'i18next';
import { Dialog, DialogButtons } from '../../../common/components/Modal/Modal';
import { PrimaryButton, TertiaryButton } from '../../../modal-flows/components/Buttons';

type Props = {
  onClosed: (confirmExit: boolean) => void;
};

export const ExitJiraConfigModal = ({ onClosed }: Props) => {
  return (
    <Dialog onDismiss={() => onClosed(false)} title={t('jiraIssueExport.modal.cancelMessage')} subtitle={t('jiraIssueExport.modal.cancelSubtitle')}>
      <DialogButtons>
        <TertiaryButton onClick={() => onClosed(false)}>{t('jiraIssueExport.modal.goBack')}</TertiaryButton>
        <PrimaryButton autoFocus onClick={() => onClosed(true)}>
          {t('jiraIssueExport.cancel')}
        </PrimaryButton>
      </DialogButtons>
    </Dialog>
  );
};
